import type {ReactElement} from 'react';
import React from 'react';
import styles from './design-seek-item-background-container.module.scss';
import {useAppSelector} from '@/hooks';

interface DesignSeekItemBackgroundContainerProps {
  pageId: string;
}

export function DesignSeekItemBackgroundContainer({pageId}: DesignSeekItemBackgroundContainerProps): ReactElement<any> {
  const pagePreviewThumbSrc = useAppSelector((state) => {
    return state.posterEditor.pagePreviews[pageId];
  });

  return (
    <div
      style={{
        backgroundImage: pagePreviewThumbSrc ? `url(${pagePreviewThumbSrc})` : undefined,
      }}
      className={`${styles.container} _full-width _full-height radius-8`}
    />
  );
}
